import { Button } from '@nazka/nazka.mapframe.components';

import './nav-item.css';

function NavItem({ children, icon, iconSize, isCollapsed, href, onClick }) {
  return (
      <div className="nav-item">
        <Button 
          className="nav-item__button" 
          onClick={onClick ? onClick : null}
          href={href ? href : null}
          icon={icon}
          iconSize={iconSize ? iconSize : '18px'}
        >
          {!isCollapsed && children}
          <span />
        </Button>
      </div>
    );
}

export default NavItem;
